<div *ngIf='{ desktop: (deviceS.isDesktop$|async),
  mobile: (deviceS.isMobile$|async),
} as obj' class='defaultPopupWrapper'>
  <headTitle text='Google Calendar Sync' *ngIf="calendarSystemToShow=='google'" svgRight='cross_grey&24'
    (svgRightEmit)='close()' typeText='text4-blueDark' />
  <headTitle text='Outlook Calendar Sync' *ngIf="calendarSystemToShow=='microsoft'" svgRight='cross_grey&24'
    (svgRightEmit)='close()' typeText='text4-blueDark' />
  <headTitle text='Apple (iCloud) Calendar Sync' *ngIf="calendarSystemToShow=='apple'" svgRight='cross_grey&24'
    (svgRightEmit)='close()' typeText='text4-blueDark' />
  <div class='contentContact scroll-area' [class.contentContact--desktop]='obj.desktop'>
    <div class='contentCalendar'>
      <div class="contentCalendar__copy">
        <field class='calendar-sync-url'>
          <inputCtrl formControlName='calendarUrl' [placeholder]="calendarSyncUrl || ''" [showErrText]='true'
            svgSuffix="copy" (svgRightEmit)='copyUrl()' [divisorySuffixLine]="true"></inputCtrl>
        </field>
      </div>
      <div class="steps-container" *ngIf="calendarSystemToShow=='google'">
        <div class="step-row">
          <span class="step-number">1</span>
          <p>Sign in to your Google Calendar</p>
        </div>
        <div class="step-row">
          <span class="step-number">2</span>
          <p>On the left, click + next to Other calendars</p>
        </div>
        <div class="step-row">
          <span class="step-number">3</span>
          <p>Select From URL and paste your Notch iCal URL</p>
        </div>
        <div class="step-row">
          <span class="step-number">4</span>
          <p>Click Add calendar and you're all set!</p>
        </div>
      </div>
      <div class="steps-container" *ngIf="calendarSystemToShow=='microsoft'">
        <div class="step-row">
          <span class="step-number">1</span>
          <p>Go to your Outlook Calendar (web or desktop)</p>
        </div>
        <div class="step-row">
          <span class="step-number">2</span>
          <p>Web version: On left, click Add calendar. Desktop version: Right click My Calendars and click Add Calendar
          </p>
        </div>
        <div class="step-row">
          <span class="step-number">3</span>
          <p>Web version: Select Subscribe from web. Desktop version: Select From Internet...</p>
        </div>
        <div class="step-row">
          <span class="step-number">4</span>
          <p>Paste your Notch iCal URL, click Import / OK and you’re all set!</p>
        </div>
      </div>
      <div class="steps-container" *ngIf="calendarSystemToShow=='apple'">
        <div class="step-row">
          <span class="step-number">1</span>
          <p>Go to your Calendar (Mobile only)</p>
        </div>
        <div class="step-row">
          <span class="step-number">2</span>
          <p>Select ‘Calendars’</p>
        </div>
        <div class="step-row">
          <span class="step-number">3</span>
          <p>In the bottom left, go to ‘Add Calendar’</p>
        </div>
        <div class="step-row">
          <span class="step-number">4</span>
          <p>Select ‘Add Subscription Calendar’</p>
        </div>
        <div class="step-row" *ngIf="calendarSystemToShow=='apple'">
          <span class="step-number">5</span>
          <p>Paste your URL, then tap ‘Subscribe’ and you’re all set!</p>
        </div>
      </div>
      <p class="final-note" *ngIf="calendarSystemToShow=='google'"><strong>Note:</strong>
        Google Calendar may take up to 24 hours to sync updates from your Notch schedule. This timing is controlled by
        Google and cannot be manually refreshed. Your Notch games will appear as a separate calendar and are ‘view
        only.’ Feel free to name the calendar ‘Notch Games’ and change the color.
      </p>
      <p class="final-note" *ngIf="calendarSystemToShow=='microsoft'"><strong>Note:</strong>
        While Outlook’s web version syncs more frequently, it may take up to 24 hours to sync updates from your Notch
        schedule. This timing is controlled by Outlook and cannot be manually refreshed. Your Notch games will appear as
        a separate calendar and are ‘view only.’ Feel free to name the calendar ‘Notch Games’ and change the color.
      </p>
      <p class="final-note" *ngIf="calendarSystemToShow=='apple'"><strong>Note:</strong>
        Apple (iCloud) Calendar takes up to 15 minutes to sync updates from your Notch schedule. This timing is
        controlled by Apple. Your Notch games will appear as a separate calendar and are ‘view only.’ Feel free to name
        the calendar ‘Notch Games’ and change the color.
      </p>
    </div>
  </div>
</div>